import { render, staticRenderFns } from "./BaseInterestIndicatorCard.vue?vue&type=template&id=4ef509fe&scoped=true&"
import script from "./BaseInterestIndicatorCard.vue?vue&type=script&lang=js&"
export * from "./BaseInterestIndicatorCard.vue?vue&type=script&lang=js&"
import style0 from "./BaseInterestIndicatorCard.vue?vue&type=style&index=0&id=4ef509fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ef509fe",
  null
  
)

export default component.exports